// extracted by mini-css-extract-plugin
module.exports = {"display":"Display_display__3uzEV","codeContainer":"Display_codeContainer__2jJyZ","copy":"Display_copy__2G9SD"};